import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { REQUEST_TYPE, Requisition, RequisitionsRequest } from './_core/approvals-page.model';
import { ApprovalsPageService } from './_core/approvals-page.service';
import { Alert, ALERT_TYPE } from '../../../components/alert/alert.model';
import { loadingStatus } from '../../../core/models/request-status.model';
import { TableProConfig } from '../../../components/table-pro/core/table-pro.model';
import { ModalService } from '../../../components/modal-list/modal-list.service';
import { ModalAccountDetailsComponent } from './components/modal-account-details/modal-account-details.component';
import { ModalRegisterDetailsComponent } from './components/modal-register-details/modal-register-details.component';
import { ModalRoleDetailsComponent } from './components/modal-role-details/modal-role-details.component';
import { ToasterService } from '../../../components/toaster/toaster.service';

@Component({
  selector: 'approvals-page',
  templateUrl: './approvals-page.component.html',
  styleUrl: './approvals-page.component.scss',
  standalone: false,
})
export class ApprovalsPageComponent implements OnInit, OnDestroy {
  requestsReq$ = new BehaviorSubject<RequisitionsRequest>({});
  subscription = new Subscription();

  alertMessage: Alert = {
    isActive: true,
    title: '',
    content: '',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  tableConfig: TableProConfig = {
    itemsPerPage: 50,
    itemsPerPageConfig: [5, 10, 15, 20, 50],
    collumnConfig: [
      { id: 'Type', index: 0, type: 'text', isOrdenable: false },
      { id: 'User', index: 1, type: 'text', isOrdenable: false },
      { id: 'Date', index: 2, type: 'date', isOrdenable: false },
      { id: 'Status', index: 3, type: 'text', isOrdenable: false },
      { id: 'Actions', index: 4, type: 'text', isOrdenable: false },
    ],
  };

  constructor(
    private approvalsPageService: ApprovalsPageService,
    private modalService: ModalService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.getRequestList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handlerOpenDetails(req: Requisition) {
    const type = req.type;

    if (type === REQUEST_TYPE.ACCOUNT) {
      this.openAccountDetails(req);
      return;
    }

    if (type === REQUEST_TYPE.REGISTER) {
      this.openRegisterDetails(req);
      return;
    }

    if (type === REQUEST_TYPE.ROLE) {
      this.openRoleDetails(req);
      return;
    }

    this.toasterService.closeALL();
    this.toasterService.displayError('Invalid request type');
  }

  openAccountDetails(req: Requisition) {
    this.modalService.create({
      id: 'modal-account-details',
      title: 'Account Details',
      width: 600,
      component: ModalAccountDetailsComponent,
      data: {
        requisition: req,
        onUpdate: () => this.getRequestList(),
      },
    });
  }

  openRegisterDetails(req: Requisition) {
    this.modalService.create({
      id: 'modal-register-details',
      title: 'Register Details',
      width: 1200,
      component: ModalRegisterDetailsComponent,
      data: {
        requisition: req,
        onUpdate: () => this.getRequestList(),
      },
    });
  }

  openRoleDetails(req: Requisition) {
    this.modalService.create({
      id: 'modal-role-details',
      title: 'Role Details',
      width: 600,
      component: ModalRoleDetailsComponent,
      data: {
        requisition: req,
        onUpdate: () => this.getRequestList(),
      },
    });
  }

  getRequestList() {
    this.requestsReq$.next(loadingStatus);

    this.subscription.add(
      this.approvalsPageService.getRequestList().subscribe(requestsReq => {
        if (requestsReq.hasError) {
          this.alertMessage.content = requestsReq.message;
        }

        // const registerReq = requestsReq.requests?.filter(req => req.type === REQUEST_TYPE.REGISTER)[0];
        // registerReq && this.handlerOpenDetails(registerReq);

        this.requestsReq$.next(requestsReq);
      }),
    );
  }
}
